export const RELATIONSHIP_OPTIONS = [
  'Spouse',
  'Partner',
  'Child',
  'Grandchild',
  'Parent',
  'Grandparent',
  'Sibling',
  'Aunt',
  'Uncle',
  'Niece',
  'Nephew',
  'Cousin',
  'Mother-in-law',
  'Father-in-law',
  'Brother-in-law',
  'Sister-in-law',
  'Son-in-law',
  'Daughter-in-law',
  'Friend',
  'Godchild',
  'Professional'
];


























